module.exports = __webpack_public_path__ + "img/shangye_wentizhongxin.81300928.png";